var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncognitoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18373_68328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C6.79063 0.5 6.6625 0.4125 6.51562 0.309375C6.30937 0.16875 6.0625 0 5.5 0C4.54688 0 3.875 1.36563 3.4375 2.79375C1.95938 3.06562 1 3.50625 1 4C1 4.44688 1.78125 4.84687 3.01875 5.12187C3.00625 5.24687 3 5.37187 3 5.5C3 6.03125 3.10313 6.5375 3.29063 7H1.41875C1.1875 7 1 7.1875 1 7.41875C1 7.47187 1.00937 7.525 1.03125 7.575L2.24375 10.6031C0.88125 11.6187 0 13.2437 0 15.0719C0 15.5844 0.415625 16 0.928125 16H13.0719C13.5844 16 14 15.5844 14 15.0719C14 13.2437 13.1187 11.6219 11.7594 10.6031L12.9688 7.575C12.9875 7.525 13 7.47187 13 7.41875C13 7.1875 12.8125 7 12.5813 7H10.7094C10.8969 6.5375 11 6.03125 11 5.5C11 5.37187 10.9937 5.24687 10.9812 5.12187C12.2188 4.84687 13 4.44688 13 4C13 3.50625 12.0406 3.06562 10.5625 2.79375C10.125 1.36563 9.45312 0 8.5 0C7.9375 0 7.69063 0.16875 7.48438 0.309375C7.3375 0.4125 7.20937 0.5 7 0.5ZM8.75 7H8.3625C7.84688 7 7.39062 6.66875 7.22813 6.18125C7.15625 5.9625 6.84688 5.9625 6.775 6.18125C6.6125 6.66875 6.15312 7 5.64062 7H5.25C4.55937 7 4 6.44063 4 5.75V5.3C4.88125 5.42813 5.90625 5.5 7 5.5C8.09375 5.5 9.11875 5.42813 10 5.3V5.75C10 6.44063 9.44063 7 8.75 7ZM6 10L6.5 11L5.5 15L4 9L6 10ZM10 9L8.5 15L7.5 11L8 10L10 9Z",
    fill: "#707A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18373_68328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoIcon);
export default __webpack_public_path__ + "static/media/incognito-icon.c20e58f3e958cd7ecdf10419a6cc120c.svg";
export { ForwardRef as ReactComponent };